<template>
  <div class="news-detail-page">
    <div class="news-hero">
      <img src="@/assets/images/新闻背景.png" alt="头图" />
      <div class="hero-text">
        <h1>品牌新闻<span class="en-title"> / NEWS CENTER</span></h1>
      </div>
    </div>

    <div class="news-detail-content">
      <h2>{{ pageTitle }}</h2>
      <p class="meta">2025-09-17 ｜ 👁 1055{{ $t('news.look') }}</p>

      <div v-if="isZh">
        <p>在泉州石狮，海洋从来不仅是自然的背景，更是孕育生计、积淀文化与寄托精神的源头。9月16日，随着开渔节的鼓点渐渐远去，祥芝码头再度迎来一场盛大而独特的盛宴——2025泉州时尚周（秋冬）开幕式暨CABBEEN卡宾25/26秋冬时装发布会。于海风与潮声的交织中，这片千年海丝起点的古老港湾，焕发出属于当代的时尚光辉。</p>
        <img src="@/assets/images/2526FW/1.png" alt="现场图1" />
        <p>当日傍晚，祥芝渔港被打造成一方流动的时尚舞台。多位重量嘉宾悉数亮相，瞬间点燃全场，将这片渔港化作镁光灯汇聚的焦点。</p>
        <p>紧接着，极具闽南底蕴的“狮阵”表演震撼登场。铿锵鼓点与灵动舞狮，与港湾停泊的渔船交相辉映，在传统与现代的碰撞中勾勒出别具一格的文化景象。伴随这一幕幕动人的表演，2025泉州时尚周由此正式启幕。</p>
        <p>随着嘉宾落座，以“远行与归途”为设计灵感的旅行箱舞台渐次亮起。箱体装置与远处的海平面叠映成层次分明的画面，寓意卡宾“行走世界，心归故里”的人生哲学。潮声与灯光交织之下，CABBEEN卡宾 25/26秋冬大秀正式揭开帷幕。</p>
        <p>海与行李箱：卡宾精神的时尚隐喻</p>
        <p>本次大秀最为瞩目的标志之一，是T台上高高矗立的四个CABBEEN卡宾“旅行箱”，灵感源自创始人卡宾先生的个人经历。作为常年穿梭于七大洲四大洋的设计师，他习惯将灵感与经验装进行李箱，却始终把心安在故乡石狮。</p>
        <img src="@/assets/images/2526FW/2.png" alt="现场图2" />
        <p>“行李箱既是漂泊的象征，也是归途的隐喻。”卡宾先生说。在他看来，品牌的灵魂不在巴黎、米兰或纽约，而在于如何将世界的语言翻译成属于闽南的语汇，再由闽南传向世界。此次舞台正是他设计哲学的具象化——模特仿佛从海天交界处走来，既是远行者，也是归来人。连续两年将大秀落地海边，这既是挑战，也体现了卡宾先生对故乡的深情。舞台搭建需与潮汐和天气赛跑，布景经受海风考验，每一个细节都彰显真实感。</p>
        <p>本次大秀的总导演肖向荣，他从旅行箱的设计出发，将卡宾28年品牌历程与家乡文化融入舞台布局。150米的长T台象征品牌的发展轨迹，旅行箱化作一道道门的装置，每个门承载品牌故事、成长记忆与文化情感。肖导本人是晋江人，而晋江与石狮相邻，所以他在大秀中也找到了深切的情感共鸣：“临海而建意味着不可控，但这种不可控才最真实。”当模特衣袖随风飞扬，海天自然光与舞美交织，观众不仅看到了时装，更感受到品牌与人、历史与文化的交织，让整场秀充满厚度与感染力。在卡宾先生看来，这场大秀不仅是一场时尚发布，更是一段与自然同频共舞的独特体验。</p>
        <img src="@/assets/images/2526FW/3.png" alt="现场图3" />
        <p>秀场直击：CABBEEN卡宾25/26秋冬全新系列</p>
        <p>在CABBEEN卡宾25/26秋冬大秀上，两大重磅联名系列成为全场瞩目焦点。除此之外，大秀还呈现了多维度的时尚篇章：西部牛仔与街头风格的碰撞，通过金属装饰与宽松廓形强化街头的随性与自由感；重工牛仔系列以水洗牛仔、拼接与特殊质感面料解构细节再生美学；商务机能风将实用性与科技感融合，高科技剪裁面料在细节中体现现代美学；法式街头风则以极简剪裁、中性色调与克制细节打造优雅舒适奢华风格；90年代港式黑色电影元素的复古篇章，通过剪裁奢华的西装与电影感的性感气质，为舞台增添戏剧张力。</p>
        <p>每一套造型在模特优雅的步伐与旋转中展现动态美，灯光与海浪的交响为服饰注入流动光影，使潮流与环境产生共鸣。</p>
        <img src="@/assets/images/2526FW/4.png" alt="现场图4" />
        <p>压轴时刻，卡宾先生奔跑在T台上向嘉宾和观众致意，最后径直走向母亲的怀抱，将全场情绪推向高潮。这一幕不仅是卡宾先生对家乡和亲情的深情回应，也象征着CABBEEN卡宾一路走来的文化坚持与潮流态度——设计、情感与传统在现代时尚的舞台上实现完美交汇。</p>
        <p>“踏山海·共潮生”不仅是一场大秀的主题，更是一次对文化根脉和时代精神的呼应。CABBEEN卡宾让观众铭记海边的舞台，也让世界听见来自中国设计的潮声——CABBEEN卡宾将以更前沿的设计理念和跨界创意，继续融合本土文化与全球潮流，让海丝文化的现代回响持续回荡，让世界感受来自中国设计的独特力量与无限想象。</p>
        <p>来源：2025泉州时尚周（秋冬）开幕式暨CABBEEN卡宾25/26秋冬时装发布会登陆泉州祥芝码头|卡宾_新浪财经_新浪网</p>
      </div>

      <div v-else>
        <p>In Shishi, Quanzhou, the ocean has never been merely a natural backdrop; it has always been a source of livelihood, a repository of culture, and a spiritual haven. On September 16, as the drumbeats of the fishing opening festival gradually faded, Xiangzhi Wharf once again welcomed a grand and unique celebration—the 2025 Quanzhou Fashion Week (Autumn/Winter) Opening Ceremony and CABBEEN 25/26 Autumn/Winter Fashion Show. Amidst the interplay of sea breeze and tidal sounds, this ancient harbor, a thousand-year-old starting point of the Maritime Silk Road, radiated a contemporary fashion brilliance.</p>
        <img src="@/assets/images/2526FW/1.png" alt="现场图1" />
        <p>That evening, Xiangzhi Fishing Port was transformed into a floating fashion stage. Numerous prominent guests made their appearances, instantly igniting the atmosphere and turning the fishing port into the focal point of flashing cameras.</p>
        <p>Immediately following, the 'Lion Dance' performance, rich in Minnan heritage, made a spectacular debut. The resounding drumbeats and lively lion dance blended with the fishing boats moored in the harbor, depicting a unique cultural scene amid the collision of tradition and modernity. Accompanied by these captivating performances, the 2025 Quanzhou Fashion Week officially commenced.</p>
        <p>As the guests took their seats, the suitcase-inspired stage, designed with the theme 'Journey and Return,' gradually lit up. The suitcase installation blended with the distant horizon to form a layered visual, symbolizing Cabbeen's life philosophy of 'travel the world, but return home in spirit.' Amid the interplay of the sound of waves and lighting, CABBEEN's Fall/Winter 25/26 show officially began.</p>
        <p>The Sea and the Suitcase: A Fashion Metaphor of the Cabin Spirit</p>
        <p>One of the most striking features of this grand show was the four towering CABBEEN travel trunks on the runway, inspired by the personal experiences of the founder, Mr. CABBEEN. As a designer who frequently travels across the seven continents and four oceans, he is accustomed to packing his inspiration and experiences into his suitcase, yet he always keeps his heart rooted in his hometown, Shishi.</p>
        <img src="@/assets/images/2526FW/2.png" alt="现场图2" />
        <p>"A suitcase is both a symbol of wandering and a metaphor for the journey home," said Mr. Cabbeen. In his view, the soul of a brand does not lie in Paris, Milan, or New York, but in how the languages of the world are translated into a vocabulary unique to Minnan, and then transmitted from Minnan to the world. This runway show is a concrete manifestation of his design philosophy—the models seem to walk from the horizon where the sea meets the sky, both as travelers and as returning souls. Hosting the grand show by the seaside for two consecutive years is both a challenge and an expression of Mr. Cabbeen's deep affection for his hometown. The stage setup must race against tides and weather, and the scenery undergoes the test of sea winds, with every detail highlighting a sense of authenticity.</p>
        <p>The chief director of this grand show, Xiao Xiangrong, started from the design of the travel suitcase, integrating Cabbeen's 28-year brand history with the culture of his hometown into the stage layout. The 150-meter-long runway symbolizes the brand's development trajectory, with travel suitcases transformed into gate-like installations, each gate carrying the brand's story, memories of growth, and cultural emotions. Director Xiao himself is from Jinjiang, and since Jinjiang is adjacent to Shishi, he found a profound emotional resonance in the show: "Building by the sea means uncontrollability, but it is precisely this uncontrollability that feels most real." As the models' sleeves fluttered in the wind and the natural light of the sea and sky intertwined with the stage design, the audience not only saw fashion but also felt the interplay between the brand and people, history, and culture, making the entire show full of depth and impact. According to Mr. Cabbeen, this grand show was not just a fashion release, but a unique experience of dancing in harmony with nature.</p>
        <img src="@/assets/images/2526FW/3.png" alt="现场图3" />
        <p>Runway Live: CABBEEN 25/26 Autumn/Winter New Collection</p>
        <p>At the CABBEEN 25/26 Autumn and Winter show, two major collaborative collections became the center of attention. In addition, the show presented multidimensional fashion chapters: the collision of Western cowboy and street styles, emphasizing casual and free-spirited street vibes through metallic decorations and loose silhouettes; the heavy denim series deconstructs details and reimagines aesthetics through washed denim, patchwork, and special textured fabrics; the business-functional style merges practicality with a sense of technology, where high-tech tailored fabrics express modern aesthetics in the details; the French street style creates an elegant, comfortable, and luxurious look through minimal tailoring, neutral tones, and restrained details; and the 1990s Hong Kong noir-inspired retro chapter adds dramatic tension to the stage with luxuriously tailored suits and the cinematic sensuality of its aesthetic.</p>
        <p>Each outfit showcases dynamic beauty through the model's graceful steps and spins, with the interplay of lighting and waves infusing the clothing with flowing light and shadow, creating a resonance between fashion and the environment.</p>
        <img src="@/assets/images/2526FW/4.png" alt="现场图4" />
        <p>At the grand finale, Mr. Cabbeen ran down the runway to greet the guests and audience, finally walking straight into his mother's embrace, pushing the atmosphere to a climax. This scene is not only Mr. Cabbeen's heartfelt response to his hometown and family, but also symbolizes CABBEEN's cultural commitment and fashion attitude throughout its journey — a perfect convergence of design, emotion, and tradition on the stage of modern fashion.</p>
        <p>"Treading Mountains and Seas · Growing with the Tide" is not only the theme of a grand show but also a response to cultural roots and the spirit of the times. CABBEEN allows the audience to remember the stage by the sea and lets the world hear the fashion waves from Chinese design—CABBEEN will continue to integrate local culture with global trends through cutting-edge design concepts and cross-disciplinary creativity, allowing the modern echoes of Maritime Silk Road culture to resonate continuously and letting the world experience the unique power and limitless imagination of Chinese design.</p>
        <p>Source: 2025 Quanzhou Fashion Week (Autumn/Winter) Opening Ceremony and CABBEEN 25/26 Autumn/Winter Fashion Show Land at Xiangzhi Wharf, Quanzhou | CABBEEN_Sina Finance_Sina.com</p>
      </div>

      <div class="back">
        <router-link to="/news" class="back-button">
          <span class="arrow">←</span> 返回 / return
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'News2526FW',
  setup() {
    const { locale } = useI18n()
    const pageTitle = computed(() => (
      locale.value === 'zh'
        ? '25/26 FW /「踏山海 · 共潮生」秋冬时装发布会'
        : "25/26 FW / 'Stepping on Mountains and Seas · Growing Together with the Tide' Autumn/Winter Fashion Show"
    ))
    const isZh = computed(() => locale.value === 'zh')
    return { pageTitle, isZh }
  },
}
</script>

<style scoped>
.news-detail-page {
  background: black;
  color: white;
  padding-bottom: 60px;
}

/* 顶部 hero */
.news-hero {
  position: relative;
  height: 230px;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}
.news-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}
.hero-text h1 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  display: inline-block;
}
.en-title {
  display: inline;
  font-size: 20px;
  font-weight: normal;
  margin-left: 8px;
  letter-spacing: 0.5px;
  color: #ffb100;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.news-detail-content {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
}
.news-detail-content p {
  line-height: 1.9; /* 行间距 */
  margin: 18px 0;   /* 段落间距 */
  text-align: justify;
  text-indent: 2em; /* 段落首行缩进 */
  font-size: 16px;
}
.news-detail-content img {
  display: block;
  max-width: 85%;
  width: auto;
  height: auto;
  margin: 20px auto; /* 图片居中 */
  border-radius: 8px;
}
.news-detail-content h2 {
  color: #ffb100;
  font-size: 26px;
  margin-bottom: 40px;
  text-align: center;
  padding: 0 20px;
}
.news-detail-content .meta {
  font-size: 13px;
  color: #aaa;
  margin-bottom: 20px;
  text-align: center;
}
.back {
  margin-top: 40px;
  text-align: center;
}
.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  background-color: #000;
  color: #ffb100;
  border: 1px solid #ffb100;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.back-button:hover {
  background-color: #ffb100;
  color: #000;
  border-color: #000;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 179, 0, 0.2);
}
.back-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(255, 179, 0, 0.2);
}
.arrow { margin-right: 8px; font-size: 18px; }

@media (max-width: 768px) {
  .news-hero { height: 180px; }
  .hero-text h1 { font-size: 18px; }
  .news-detail-content { max-width: 100%; margin: 20px 10px; padding: 0 10px; }
  .news-detail-content h2 { font-size: 22px; }
  .news-detail-content .meta { font-size: 12px; }
  .news-detail-content img { max-width: 100%; }
}
</style>

